import {GetterTree} from "vuex";
import {RootState} from "@service/store/types/RootState";
import {FavoritesState} from "@service/store/types/FavoritesState";

export const isObjectInFavoritesGetter = 'favorites/isObjectInFavorites';

export const getters: GetterTree<FavoritesState, RootState> = {
    isObjectInFavorites: state => (schemaId: string, objectId: string) => {
        if (state.list[schemaId] && state.list[schemaId].length) {
            return state.list[schemaId].indexOf(objectId) >= 0;
        }

        return false;
    },
    unreadedLsKey: (_, __, rootState) => {
        return `${rootState.session.backend}_unreaded-favorites_${rootState.events?.selected || 'unknown-eventId'}_${rootState.session.userId}`
    }
}
